<template>
  <div class="offer-customizer">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>

    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 1fr) minmax(0, 2fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <div style="display:inherit;;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:auto">
            <div class="Polaris-LegacyCard" v-if="config.carouselConfig">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      App Block Settings
                    </h2>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(2, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Minimum Ratings to display</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-Select">
                                <select
                                  id=":Rq6:"
                                  class="Polaris-Select__Input"
                                  aria-invalid="false"
                                  v-model.number="config.minRatingToDisplay"
                                >
                                  <option value="1">1</option>

                                  <option value="2">2</option>

                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                </select>
                                <div
                                  class="Polaris-Select__Content"
                                  aria-hidden="true"
                                >
                                  <span
                                    class="Polaris-Select__SelectedOption"
                                    >{{ config.minRatingToDisplay }}</span
                                  >
                                  <span class="Polaris-Select__Icon">
                                    <span class="Polaris-Icon">
                                      <svg
                                        viewBox="0 0 20 20"
                                        class="Polaris-Icon__Svg"
                                        focusable="false"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                                        ></path>
                                        <path
                                          d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                                        ></path>
                                      </svg>
                                    </span>
                                  </span>
                                </div>
                                <div class="Polaris-Select__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Colors
                    </h2>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(1, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Card Background Color</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="
                                    config.carouselConfig.cardBackgroundColor
                                  "
                                  autocomplete="off"
                                  class="Polaris-TextField__Input hasColor"
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />
                                <verte
                                  picker="square"
                                  v-model="
                                    config.carouselConfig.cardBackgroundColor
                                  "
                                  class="colorPicker"
                                  model="hex"
                                >
                                </verte>

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Star Color</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="config.carouselConfig.starColor"
                                  autocomplete="off"
                                  class="Polaris-TextField__Input hasColor"
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />
                                <verte
                                  picker="square"
                                  v-model="config.carouselConfig.starColor"
                                  class="colorPicker"
                                  model="hex"
                                >
                                </verte>

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Text Color</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="config.carouselConfig.textColor"
                                  autocomplete="off"
                                  class="Polaris-TextField__Input hasColor"
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />
                                <verte
                                  picker="square"
                                  v-model="config.carouselConfig.textColor"
                                  class="colorPicker"
                                  model="hex"
                                >
                                </verte>

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Button Background Color</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="
                                    config.carouselConfig.buttonBackgroundColor
                                  "
                                  autocomplete="off"
                                  class="Polaris-TextField__Input hasColor"
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />
                                <verte
                                  picker="square"
                                  v-model="
                                    config.carouselConfig.buttonBackgroundColor
                                  "
                                  class="colorPicker"
                                  model="hex"
                                >
                                </verte>

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Container Background Color</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="
                                    config.carouselConfig
                                      .containerBackgroundColor
                                  "
                                  autocomplete="off"
                                  class="Polaris-TextField__Input hasColor"
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />
                                <verte
                                  picker="square"
                                  v-model="
                                    config.carouselConfig
                                      .containerBackgroundColor
                                  "
                                  class="colorPicker"
                                  model="hex"
                                ></verte>

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Leave Review Button Label</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="
                                    config.carouselConfig.reviewButtonLabel
                                  "
                                  autocomplete="off"
                                  class="Polaris-TextField__Input "
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id=":R1mq6:Label"
                                for=":R1mq6:"
                                class="Polaris-Label__Text"
                                >Reviews Count Label</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-TextField ">
                                <input
                                  id=":R1mq6:"
                                  v-model="
                                    config.carouselConfig.reviewCountLabel
                                  "
                                  autocomplete="off"
                                  class="Polaris-TextField__Input "
                                  type="text"
                                  aria-labelledby=":R1mq6:Label"
                                  aria-invalid="false"
                                  data-1p-ignore="true"
                                  data-lpignore="true"
                                  data-form-type="other"
                                  value=""
                                />

                                <div class="Polaris-TextField__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Polaris-FormLayout__Item ">
                        <div class="">
                          <div class="Polaris-Labelled__LabelWrapper">
                            <div class="Polaris-Label">
                              <label
                                id="showProfileImagesLabel"
                                for="showProfileImages"
                                class="Polaris-Label__Text"
                                >Show Google Icon</label
                              >
                            </div>
                          </div>
                          <div class="Polaris-Connected">
                            <div
                              class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                            >
                              <div class="Polaris-Choice">
                                <label
                                  class="Polaris-Choice__Label flex"
                                  for="showProfileImages"
                                >
                                  <div class="Polaris-Choice__Control">
                                    <div class="Polaris-Checkbox">
                                      <input
                                        id="showProfileImages"
                                        v-model="
                                          config.carouselConfig.showGoogleImage
                                        "
                                        type="checkbox"
                                        class="Polaris-Checkbox__Input"
                                        role="checkbox"
                                        aria-checked="false"
                                        aria-labelledby="showProfileImagesLabel"
                                      />
                                      <div
                                        class="Polaris-Checkbox__Backdrop"
                                      ></div>
                                      <div class="Polaris-Checkbox__Icon">
                                        <svg
                                          viewBox="0 0 20 20"
                                          class="Polaris-Icon__Svg"
                                          focusable="false"
                                          aria-hidden="true"
                                        >
                                          <path
                                            d="M8.315 13.859L3.56 9.104a.5.5 0 0 1 .708-.708l4.047 4.047 7.894-7.894a.5.5 0 0 1 .708.708l-8.5 8.5a.5.5 0 0 1-.708 0z"
                                            fill-rule="evenodd"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="Polaris-Choice__LabelText">
                                    Display Google icon in reviews
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                  Preview
                </h2>
                <WidgetPreview
                  v-if="config.carouselConfig"
                  :config="config"
                  class="mt-4"
                ></WidgetPreview>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="color:var(--p-color-text-info-on-bg-fill);width:auto">
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <div class="flex items-center justify-between">
                  <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                    Custom CSS
                  </h2>
                  <button
                    class="Polaris-Button"
                    type="button"
                    @click="openCrispChat"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text"
                        >Need help to customize?</span
                      >
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                role="group"
              >
                <div class="Polaris-FormLayout__Item">
                  <div class="">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label
                          id="customCssLabel"
                          for="customCss"
                          class="Polaris-Label__Text"
                          >Add custom CSS styles</label
                        >
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                      >
                        <div
                          class="Polaris-TextField Polaris-TextField--multiline"
                        >
                          <textarea
                            id="customCss"
                            v-model="config.customCss"
                            class="Polaris-TextField__Input"
                            type="text"
                            aria-labelledby="customCssLabel"
                            aria-invalid="false"
                            style="height: 200px; resize: vertical;"
                            placeholder="Example:
.carousel-wrapper {
  padding: 20px;
  border-radius: 8px;
}
.carousel-card {
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}"
                          ></textarea>
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                    <div class="Polaris-Labelled__HelpText">
                      Add custom CSS to further customize the widget appearance.
                      You can target these classes: .carousel-wrapper,
                      .carousel-card, .carousel-header-container,
                      .write-review-button, .rating-stars, .star-container
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

import { cloneDeep } from "lodash-es";

import WidgetPreview from "./WidgetPreview.vue";

export default {
  components: {
    Verte,
    WidgetPreview
  },
  data() {
    return {
      config: {},
      originalConfig: {},
      hasUnsavedChanges: false,
      saveBar: null
    };
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },

  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      return next(false);
    }
  },

  methods: {
    init() {
      this.$store.dispatch("getWidgetConfig").then(response => {
        this.config = cloneDeep(response.config);
        this.originalConfig = cloneDeep(response.config);
      });
    },

    updateSettings() {
      const payload = this.config;
      delete payload.id;

      this.$store
        .dispatch("updateWidgetConfig", { requestParams: payload })
        .then(response => {
          this.$store.dispatch("showNotification", {
            text: "Settings updated"
          });
          this.hasUnsavedChanges = false;
          this.config = cloneDeep(response.config);
          this.originalConfig = cloneDeep(response.config);
        });
    },
    checkForChanges() {
      if (JSON.stringify(this.config) !== JSON.stringify(this.originalConfig)) {
        console.log({ config: JSON.stringify(this.config) });
        console.log({ originalConfig: JSON.stringify(this.originalConfig) });
        this.saveBar.show();
        this.hasUnsavedChanges = true;
        console.log("should show contextual bar");
      } else {
        this.hasUnsavedChanges = false;
        this.saveBar.hide();
      }
    },
    onSaveBarSaveClicked() {
      this.updateSettings();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },
    openCrispChat() {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:open"]);
        window.$crisp.push([
          "do",
          "message:send",
          ["text", "Need help to customize the widget"]
        ]);
      }
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 4px;
  left: 8px;
  z-index: 100;
}

/* Target the color picker when it's active/open */
.verte.colorPicker .verte__menu-origin--active {
  z-index: 10000 !important;
}

/* Also ensure the parent element has higher z-index when active */
.verte.colorPicker:has(.verte__menu-origin--active) {
  z-index: 10000 !important;
}

/* For browsers that don't support :has selector */
.Polaris-Connected__Item--primary:focus-within .verte.colorPicker,
.Polaris-Connected__Item--primary:hover .verte.colorPicker {
  z-index: 10000 !important;
}

.Polaris-TextField__Input.hasColor {
  padding-left: 42px;
}
.offer-customizer .Polaris-LegacyCard {
  overflow: visible;
}
.offer-customizer .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}
.offer-customizer .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
